import React from 'react'

import Section from '../../../../../components/Section'
import ContractPerformanceTable from './ContractPerformanceTab/Table/ContractPerformanceTable'
import { Contract, ContractPerformance } from '../../types'
import { CurrencyList } from '../types'

type Props = {
    contractGuid: string
    contractRegNumber: string
    contractSubjectContract: string | null
    contractPrice: number
    contractCurrencyName: string
    contractStartExecutionDate: string | null
    contractEndExecutionDate: string | null
    theme: string
    isActive: boolean
    currencyList: CurrencyList[]
    contractRubPrice: number | null
    dataReloadToken: number
}

const ContractPerformanceTab: React.FC<Props> = (props) => {
    return (
        <Section title="Информация об исполнении">
            <div className="flex flex-col w-full gap-x-5 ">
                <ContractPerformanceTable
                    theme={props.theme}
                    contractGuid={props.contractGuid}
                    contractRegNumber={props.contractRegNumber}
                    isActive={props.isActive}
                    currencyList={props.currencyList}
                    contractPrice={props.contractPrice}
                    contractRubPrice={props.contractRubPrice}
                    dataReloadToken={props.dataReloadToken}
                />
            </div>
        </Section>
    )
}

export default ContractPerformanceTab
